import * as yup from "yup";

export const AccountMigrationSchema = yup.object({
  email: yup
    .string()
    .required("Обязательное поле")
    .email("Неверный формат email"),
  password: yup
    .string()
    .required("Пароль обязателен")
    .min(8, "Пароль должен содержать не менее 8 символов")
    .matches(
      /[a-z]/,
      "Пароль должен содержать хотя бы одну строчную букву латинницы"
    )
    .matches(
      /[A-Z]/,
      "Пароль должен содержать хотя бы одну заглавную букву латинницы"
    ),
  doublePassword: yup
    .string()
    .required("Подтверждение пароля обязательно")
    .oneOf([yup.ref("password")], "Пароли не совпадают"),
});

export type AccountMigrationFormValues = yup.InferType<
  typeof AccountMigrationSchema
>;
